import { AuthenticatedDataRequest } from '@eggplant/data-request'
import {
  Combobox,
  DropdownButton,
  NoOptionsPlaceholder
} from '@eggplant/pattern-library'
import { FiTag } from 'react-icons/fi'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'
import type {
  ButtonShape,
  DropdownPlacement,
  Options,
  Tag
} from '@eggplant/types'

interface Props {
  onChange: (value: string) => void
  placeholder?: string
  value?: string
  dropdownPlacement?: DropdownPlacement
  isFilterFixedMinMaxWidth?: boolean
}

const url = TEST_CONFIG_SERVICE + '/tags'

const getOptions = (items: Tag[] | undefined) => {
  if (!Array.isArray(items)) return []

  return items.map(item => ({
    label: item.name,
    value: item.id
  }))
}

const SelectTestConfigTag = ({
  onChange,
  placeholder = 'Test config tag',
  value,
  dropdownPlacement = 'bottom',
  isFilterFixedMinMaxWidth = true
}: Props) => {
  const renderButton = (options: Options) => {
    const currentOption = options.find(item => item.value === value)

    const label = currentOption?.value
      ? currentOption.label
      : placeholder

    const tooltip = currentOption?.value
      ? `Test config tag: ${currentOption.label}`
      : label

    const buttonText = currentOption?.value
      ? currentOption.label
      : placeholder

    return (buttonProps: ButtonShape) =>
      <DropdownButton
        {...buttonProps}
        Icon={FiTag}
        dropdownPlacement={dropdownPlacement}
        isFilter
        isFilterFixedMinMaxWidth={isFilterFixedMinMaxWidth}
        isHighlighted={!!value}
        label={label}
        title={tooltip}
      >
        {buttonText}
      </DropdownButton>
  }

  const noDataPlaceholder =
    <NoOptionsPlaceholder
      icon={<FiTag size='24px' />}
      title='No test config tag found'
    />

  return (
    <AuthenticatedDataRequest
      method='get'
      shortErrorMessage='Failed to load Test config tag'
      url={url}
    >
      {
        ({ items }) =>
          <Combobox
            dropdownPlacement={dropdownPlacement}
            isFilter
            isFilterFixedMinMaxWidth={isFilterFixedMinMaxWidth}
            noOptionsPlaceholder={noDataPlaceholder}
            onChange={onChange}
            options={getOptions(items)}
            renderButton={renderButton(getOptions(items))}
            value={value}
          />
      }
    </AuthenticatedDataRequest>
  )
}

export default SelectTestConfigTag
